module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO26PresupuestoMensual.54ba870.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO26PresupuestoMensual.mp4
// module id = 752
// module chunks = 1